const styles = (theme) => ({
  root: {
    width: '100%',
    '& .Mui-focused .MuiSelect-select': {
      backgroundColor: 'transparent',
    },
  },
  itemSelected: {
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  itemName: {
    whiteSpace: 'normal',
    paddingRight: theme.spacing(1),
  },
});

export default styles;
